// Add your custom JS here.
document.addEventListener('DOMContentLoaded', function () {

	// Select all anchor tags with href attributes starting with "#"
	const anchors = document.querySelectorAll('.entry-content a[href^="#"]');

	anchors.forEach(anchor => {
		anchor.addEventListener('click', function (e) {
			// Prevent the default link click behavior
			e.preventDefault();

			// Get the target element
			let target = document.querySelector(this.getAttribute('href'));

			// Set the offset based on the screen width
			let offset = window.innerWidth < 992 ? 250 : 150;

			// If the target element is found
			if (target) {
				// Calculate the position of the element and adjust with the offset
				let targetPos = target.getBoundingClientRect().top + window.scrollY;

				// Scroll to the adjusted position with a smooth behavior
				window.scrollTo({
					top: targetPos - offset,
					behavior: 'smooth',
				});
			}
		});
	});

	var dropdownToggles = document.querySelectorAll('.dropdown-toggle');

	dropdownToggles.forEach(function (toggle) {
		toggle.addEventListener('click', function (e) {
			if (window.innerWidth < 992) {
				e.preventDefault();
				e.stopPropagation();  // Add this line to stop propagation
				var menu = this.nextElementSibling;
				menu.style.display = (menu.style.display === 'block') ? 'none' : 'block';
			}
		}, false);
	});

	window.addEventListener('resize', function () {
		if (window.innerWidth >= 992) {
			var dropdownMenus = document.querySelectorAll('.dropdown-menu');
			dropdownMenus.forEach(function (menu) {
				menu.style.display = '';
			});
		}
	}, true);

	// header background after scrolling 150px
	let header = document.getElementById('wrapper-navbar');
	let thresholdPosition = 150;  // Scroll distance before adding the class

	window.onscroll = function () {
		let scrollPosition = window.scrollY;

		if (scrollPosition > thresholdPosition) {
			header.classList.add('has-nav-background');
		} else {
			header.classList.remove('has-nav-background');
		}
	};


	profilePageMediaBlock();
	

	var accordionButtons = document.querySelectorAll('.accordion-button');

	accordionButtons.forEach(function(button) {
		button.addEventListener('click', function(event) {
			// Prevent multiple triggers
			event.stopPropagation();

			// The accordion item being interacted with
			var currentAccordionItem = button.closest('.accordion-item');
			var currentAccordionCollapse = currentAccordionItem.querySelector('.accordion-collapse');

			// Check if the current accordion item is being opened or closed
			var isOpening = !currentAccordionCollapse.classList.contains('show');

			if (isOpening) {
				// Close other accordion items
				var otherAccordionItems = document.querySelectorAll('.accordion-item');
				otherAccordionItems.forEach(function(otherItem) {
					if (otherItem !== currentAccordionItem) {
						var otherItemCollapse = otherItem.querySelector('.accordion-collapse');
						// Use Bootstrap's collapse method to hide other accordion items
						var collapseInstance = new bootstrap.Collapse(otherItemCollapse, {
							toggle: false
						});
						collapseInstance.hide();
					}
				});
			}
		});
	});

});

function profilePageMediaBlock() {
	// Only proceed if we're on a page with the class .page-id-16
	const profilePage = document.querySelector('.page-id-16');
	if (profilePage) {
		const profilePageMediaBlock = document.querySelector('.page-id-16 .profile-block .wp-block-column:first-child');
		const profilePageColumns = document.querySelector('.page-id-16 .rearrange-help');
		const firstColumn = profilePageColumns ? profilePageColumns.querySelector('.wp-block-column:first-child') : null;

		// Check if all required elements exist
		if (profilePageMediaBlock && profilePageColumns && firstColumn) {
			if (window.innerWidth <= 781) {
				// Move the media block to the start of the columns container
				profilePageColumns.insertBefore(profilePageMediaBlock, firstColumn);
			} else {
				// Check if the media block is already moved, and move it back if needed
				// const parentOfMediaBlock = profilePageMediaBlock.parentNode;
				// if (parentOfMediaBlock !== profilePage) {
				// 	profilePageColumns.appendChild(profilePageMediaBlock);
				// }
			}
		}
	}
}

